/**
 * Do not edit directly
 */

export default "PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTgsLjVBNy41LDcuNSwwLDEsMCwxNS41LDgsNy41MSw3LjUxLDAsMCwwLDgsLjVabTAsMTRBNi41LDYuNSwwLDEsMSwxNC41LDgsNi41MSw2LjUxLDAsMCwxLDgsMTQuNVoiLz48cG9seWdvbiBwb2ludHM9IjcuMDQgOS4zMyA1LjM1IDcuNjUgNC42NSA4LjM1IDYuOTYgMTAuNjcgMTIuMzEgNi4zOSAxMS42OSA1LjYxIDcuMDQgOS4zMyIvPjwvc3ZnPg==";